// extracted by mini-css-extract-plugin
module.exports = {"container":"List_container_14V28","batchTable":"List_batchTable_Yq6WT","detail":"List_detail_t-lZT"};